import Raven from 'raven-js';
import { useSelector } from 'react-redux';
import { getUser } from '../../selectors';
import { startBrowserNotifications } from '.';
import { memo, useEffect } from 'react';
export const BrowserNotificationsServiceWorker = /*#__PURE__*/memo(() => {
  const user = useSelector(getUser);
  useEffect(() => {
    startBrowserNotifications(user.user_id).catch(e => Raven.captureException(e));
  }, [user.user_id]);
  return null;
});